import styled from 'styled-components';

import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Container = styled.div`
    width: 100%;
    margin: 0 auto -50px;
    background-color: ${COLORS.BgMain};
`;

export const ReviewsGridContainer = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    width: 1570px;
    padding-top: 48px;
    padding-bottom: 48px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 1280px;
        padding-top: 32px;
        padding-bottom: 32px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 32px 16px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px 16px;
    }
`;

export const ReviewsGridLocations = styled.div`
    display: grid;
    width: 100%;
    grid-template-areas:    'average list'
                            'help list';
    grid-template-rows: 432px auto;
    grid-template-columns: 480px auto;
    column-gap: 32px;
    row-gap: 16px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-template-rows: 480px auto;
        grid-template-columns: 376px auto;
        column-gap: 24px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        grid-template-areas:    'average'
                                'list'
                                'help';
        grid-template-rows: 1fr auto auto;
        grid-template-columns: 100%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        row-gap: 8px;
    }
`;
